import CardIcon from '@shared/components/core/card/CardIcon';
import { useTranslation } from 'react-i18next';
import OrgLinks from '../OrgLinks';

interface IOrgMetricsCardProps {
    orgId: string;
}

export default function OrgSettingsCard({ orgId }: IOrgMetricsCardProps) {
    const { t } = useTranslation();

    if (!orgId) return null;
    return (
        <CardIcon
            name="settings"
            title={t('common:settings.title')}
            description={t('common:organization.settings.description')}>
            <OrgLinks organizationId={orgId} variant={'orgSettings'} />
        </CardIcon>
    );
}
